 <div *ngIf="!refreshLoading && !startTime && gameType != 'FISH'">
    <div class="banner">
        <owl-carousel-o [options]="customOptions">
          <ng-template carouselSlide *ngFor="let adsObj of this.adsList">
            <div class="slide">
              <a [href]="(adsObj.linkUrl == null || adsObj.linkUrl == '') ? 'javascript:void(0)': (adsObj.linkUrl+''+openUrl | safeUrl)" *ngIf="adsObj.linkUrl != null">
                <img [src]="adsObj.imageUrl" alt="AdsImage">
              </a>
              <img [src]="adsObj.imageUrl" alt="AdsImage" *ngIf="adsObj.linkUrl == null">
            </div>
          </ng-template>
        </owl-carousel-o>  
    </div>

    <div class="banner-text" *ngIf = "marqueeText != null">
      <!-- <div class="banner-text-inner">
        <marquee direction="left" scrollamount="3"><h5>{{marqueeText.marqueeText}}</h5></marquee>
      </div> -->
          <div class="marquee-container banner-text-inner">
          <div class="marquee-text">
            {{ marqueeText.marqueeText }}
          </div>
          </div>
    </div>
</div>

<div *ngIf="!refreshLoading && !startTime && gameType == 'FISH'">
  <div class="banner" style="margin-top: 70px !important;">
      <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide *ngFor="let adsObj of this.adsList">
          <div class="slide">
            <a [href]="(adsObj.linkUrl == null || adsObj.linkUrl == '') ? 'javascript:void(0)': (adsObj.linkUrl+''+openUrl | safeUrl)" *ngIf="adsObj.linkUrl != null">
              <img [src]="adsObj.imageUrl" alt="AdsImage">
            </a>
            <img [src]="adsObj.imageUrl" alt="AdsImage" *ngIf="adsObj.linkUrl == null">
          </div>
        </ng-template>
      </owl-carousel-o>  
  </div>

  <div class="banner-text" *ngIf = "marqueeText != null">
    <!-- <div class="banner-text-inner">
      <marquee direction="left" scrollamount="3"><h5>{{marqueeText.marqueeText}}</h5></marquee>
    </div> -->
     <div class="marquee-container banner-text-inner">
          <div class="marquee-text">
            {{ marqueeText.marqueeText }}
          </div>
    </div>
  </div>
</div>

<!-- refresh loading -->
<ngx-spinner [name]="common.loading.refreshLoading.name" [size]="common.loading.refreshLoading.size"
  [color]="common.loading.refreshLoading.color" [type]="common.loading.refreshLoading.type"
  [fullScreen]="common.loading.refreshLoading.fullScreen"></ngx-spinner>